import React, { useEffect, useState } from "react";
import "./ActivationStep.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import {
  deleteActivationSteps,
  getActivationSteps,
} from "../../../../requests/articleAPI";
import { toast } from "react-toastify";
const ActivationStep = () => {
  const [rows, setRows] = useState([]);
  const [id, setId] = useState();

  const allChecked = rows.every((row) => row.selected);

  const handleSelectAll = () => {
    const newValue = !allChecked;
    setRows(rows.map((row) => ({ ...row, selected: newValue })));
  };

  const handleRowSelect = (index) => {
    const updated = [...rows];
    updated[index].selected = !updated[index].selected;
    setRows(updated);
  };

  const userFormik = useFormik({
    initialValues: {
      serviceType: "",
      vendor: "",
      markupPercentage: "",
      confirmPercentage: "",
    },
    validationSchema: Yup.object({
      serviceType: Yup.string().required("Please select a service type"),

      vendor: Yup.string(), // Optional

      markupPercentage: Yup.number()
        .typeError("Must be a number")
        .min(0, "Must be at least 0")
        .max(100, "Cannot exceed 100")
        .required("percentage is required"),

      confirmPercentage: Yup.number()
        .typeError("Must be a number")
        .oneOf([Yup.ref("markupPercentage")], "Must match markup percentage")
        .required("percentage is required"),
    }),
    onSubmit: (values) => {
      console.log("Form values:", values);
      alert(JSON.stringify(values, null, 2));
    },
  });
  const deleteActivationStep = async () => {
    try {
      const result = await deleteActivationSteps(id);
      getAllActivationSteps();
      if (result.status == 200) {
        toast.success("Data Deleted Successfully!");
      }
    } catch (error) {
      console.error("Error deleting activation step:", error);
      toast.success("Something Went Wrong!");
    } finally {
      document.getElementById("closeDeleteModalBtn")?.click();
    }
  };
  const getAllActivationSteps = async () => {
    try {
      const result = await getActivationSteps();
      const formatted = result.data.map((item) => ({
        title: item.title,
        category: item.category,
        lastUpdated: item?.createdAt, // e.g., Aug 07, 2025
        status: item.status || "Inactive",
        version: item.version,
        editor: item.userId?.fullName
          ? item.userId?.fullName
          : item.userId?.email, // from your data
        action: <img src="/images/icons/pen.svg" alt="icon" />,
        img: <img src="/images/icons/cross-circle.svg" alt="icon" />,
        selected: false,
        id: item._id,
      }));
      setRows(formatted);
      // console.log(formatted);
    } catch (error) {}
  };
  useEffect(() => {
    getAllActivationSteps();
  }, []);
  return (
    <section className="activation-page-section">
      <div className="search-input">
        <h5 className="form-title">Activation Steps</h5>
        <Link to="/add-activation-steps" className="custom-btn">
          Add Activation Steps
        </Link>
      </div>
      <div className="table-responsive">
        <table className="table table-striped vendor-info">
          <thead className="table-dark">
            <tr>
              <th>
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleSelectAll}
                  />
                  <span className="checkmark"></span>
                </label>
              </th>
              <th>Title</th>
              <th>Category</th>
              <th>Last Updated</th>
              <th>Status</th>
              <th>Version</th>
              <th>Editor(s)</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                <td>
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={row.selected}
                      onChange={() => handleRowSelect(i)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </td>
                <td>{row.title}</td>
                <td>{row.category}</td>
                <td>{row.lastUpdated}</td>
                <td>{row.status}</td>
                <td>{row.version}</td>
                <td>{row.editor}</td>
                <td>
                  <span className="action-link">
                    <Link to={`/edit-activation-steps/${row.id}`}>
                      {row.action}
                    </Link>
                    <div
                      data-bs-toggle="modal"
                      data-bs-target="#cancelModal"
                      onClick={() => setId(row.id)}
                    >
                      {row.img}
                    </div>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        className="modal fade"
        id="activationManagementModal"
        tabIndex="-1"
        aria-labelledby="activationManagementModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content activationManagement-modal">
            <div className="modal-body">
              <div className="modal-header">
                <h5 className="modal-title">Add Markup</h5>
                <img
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  src="/images/icons/close-circle.svg"
                  alt="close-circle"
                />
              </div>
              <form className="user-info" onSubmit={userFormik.handleSubmit}>
                <div className="user-inputs">
                  <div className="row">
                    <strong className="mb-2">Select Service & Vendor</strong>
                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <input
                          type="text"
                          name="serviceType"
                          placeholder="eSim"
                          value={userFormik.values.serviceType}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <label className="floating-label-text">
                          Service Type
                        </label>
                        {userFormik.touched.serviceType &&
                          userFormik.errors.serviceType && (
                            <div className="error">
                              {userFormik.errors.serviceType}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <select
                          name="vendor"
                          value={userFormik.values.vendor}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        >
                          <option value="">Choose Service Type</option>
                          <option value="eSim">eSim</option>
                          <option value="Flights">Flights</option>
                          <option value="Hotel">Hotel</option>
                          <option value="Tours">Tours</option>
                        </select>
                        <label className="floating-label-text">
                          Vendor (Optional)
                        </label>
                        {userFormik.touched.vendor &&
                          userFormik.errors.vendor && (
                            <div className="error">
                              {userFormik.errors.vendor}
                            </div>
                          )}
                      </div>
                    </div>

                    <strong className="mb-2 mt-3">Markup Percentage</strong>

                    <div className="col-md-6 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="markupPercentage"
                          placeholder="000"
                          value={userFormik.values.markupPercentage}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <span>GB</span>
                        <label className="floating-label-text">
                          Percentage
                        </label>
                        {userFormik.touched.markupPercentage &&
                          userFormik.errors.markupPercentage && (
                            <div className="error">
                              {userFormik.errors.markupPercentage}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-md-6 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="confirmPercentage"
                          placeholder="000"
                          value={userFormik.values.confirmPercentage}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <span>%</span>
                        <label className="floating-label-text">
                          Percentage
                        </label>
                        {userFormik.touched.confirmPercentage &&
                          userFormik.errors.confirmPercentage && (
                            <div className="error">
                              {userFormik.errors.confirmPercentage}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn">
                    Add Markup
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="cancelModal"
        tabIndex="-1"
        aria-labelledby="cancelModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content markup-modal">
            <div className="modal-body">
              <h5 className="modal-title">Delete Activation Step</h5>
              <p>Are you sure you want to remove this entry. </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn"
                onClick={() => deleteActivationStep(id)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
        <button
          type="button"
          id="closeDeleteModalBtn"
          data-bs-dismiss="modal"
          style={{ display: "none" }}
        ></button>
      </div>
    </section>
  );
};

export default ActivationStep;
